import { gerarAlertasAutomaticos } from './alertasService.js'
import { getAlertas } from './crud.js'

const LAST_CHECK_KEY = 'minha-obra-alertas-last-check'
const LAST_NOTIFY_KEY = 'minha-obra-alertas-last-notify'
const CHECK_INTERVAL_MS = 6 * 60 * 60 * 1000 // 6h
const NOTIFY_COOLDOWN_MS = 24 * 60 * 60 * 1000 // 24h

function canUseNotifications(): boolean {
  return (
    typeof window !== 'undefined' &&
    'Notification' in window &&
    Notification.permission === 'granted'
  )
}

async function notifyIfNeeded(ativoCount: number): Promise<void> {
  if (!canUseNotifications() || ativoCount === 0) return
  const last = Number(localStorage.getItem(LAST_NOTIFY_KEY) ?? 0)
  if (Date.now() - last < NOTIFY_COOLDOWN_MS) return
  try {
    new Notification('Minha Obra · alertas pendentes', {
      body: `${ativoCount} alerta${ativoCount > 1 ? 's' : ''} ativo${ativoCount > 1 ? 's' : ''}. Toque para revisar.`,
      tag: 'obra-alertas',
    })
    localStorage.setItem(LAST_NOTIFY_KEY, String(Date.now()))
  } catch {
    /* ignore — some browsers block without gesture */
  }
}

/** Verifica alertas em background e dispara notificação local se permitido. */
export async function runAlertasProativos(): Promise<number> {
  const last = Number(localStorage.getItem(LAST_CHECK_KEY) ?? 0)
  if (Date.now() - last < CHECK_INTERVAL_MS) {
    const all = await getAlertas()
    return all.filter((a) => (a.status ? a.status === 'ativo' : !a.lido)).length
  }
  await gerarAlertasAutomaticos()
  localStorage.setItem(LAST_CHECK_KEY, String(Date.now()))
  const all = await getAlertas()
  const ativos = all.filter((a) => (a.status ? a.status === 'ativo' : !a.lido))
  await notifyIfNeeded(ativos.length)
  return ativos.length
}

export async function requestAlertasNotificationPermission(): Promise<boolean> {
  if (!('Notification' in window)) return false
  if (Notification.permission === 'granted') return true
  if (Notification.permission === 'denied') return false
  const result = await Notification.requestPermission()
  return result === 'granted'
}
